import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolderArrowRight32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFolderArrowRight32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.394 8H7a1 1 0 0 0-1 1v1h8.263l-1.037-1.555A1 1 0 0 0 12.394 8m4.273 2L14.89 7.336A3 3 0 0 0 12.394 6H7a3 3 0 0 0-3 3v6a1 1 0 1 0 2 0v-3h18a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H8c-1.105 0-2-.894-2-1.998v-.042a1 1 0 1 0-2 0v.042A4 4 0 0 0 8 27h16a4 4 0 0 0 4-4v-9a4 4 0 0 0-4-4zM9.058 21.13a1 1 0 1 0 1.415 1.414l2.828-2.828.707-.707-.707-.708-2.828-2.828a1 1 0 1 0-1.415 1.414l1.11 1.11H5a1 1 0 1 0 0 2h5.191z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFolderArrowRight32);
